import React, {useState, useRef, useEffect, useCallback} from "react";
import cx from "classnames";
import { useSwipeable } from "react-swipeable";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';

import {Button} from "@mui/material";

import Step1 from "../../../static/images/steps/Step1.jpg";
import Step2 from "../../../static/images/steps/Step2.jpg";
import Step3 from "../../../static/images/steps/Step3.jpg";
import Step4 from "../../../static/images/steps/Step4.jpg";
import Step5 from "../../../static/images/steps/Step5.jpg";
import Step6 from "../../../static/images/steps/Step6.jpg";
import Step7 from "../../../static/images/steps/Step7.jpg";
import Step1Small from "../../../static/images/steps/Step1-small.jpg";
import Step2Small from "../../../static/images/steps/Step2-small.jpg";
import Step3Small from "../../../static/images/steps/Step3-small.jpg";
import Step4Small from "../../../static/images/steps/Step4-small.jpg";
import Step5Small from "../../../static/images/steps/Step5-small.jpg";
import Step6Small from "../../../static/images/steps/Step6-small.jpg";
import Step7Small from "../../../static/images/steps/Step7-small.jpg";

import ButtonPrimary from "../../../components/button-primary/ButtonPrimary";
import {VEDMARKET_LINKS} from '../../../constants';
import PlusIcon from '../../../static/icons/plus.svg';
import StepsModal from "./StepsModal";

import styles from './Steps.module.scss';
import {COLORS} from "../../../config/constants";

function Steps() {

    const [currentIndex, setCurrentIndex] = useState(0);

    const [open, setOpen] = React.useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    const [ firstSlideHeight, setFirstSlideHeight ] = useState<number | undefined>();

    const firstSlideRef = useRef<HTMLImageElement | null>(null);

    const updateHeight = useCallback(() => {
        const img = firstSlideRef.current;
        if (img) {
            const height = img.offsetHeight || (isMobile ? img.naturalHeight : img.naturalHeight / 2);
            setFirstSlideHeight(height);
        }
    }, [isMobile]);

    useEffect(() => {
        updateHeight();

        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener("resize", updateHeight);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener("resize", updateHeight);
        }
    }, [ isMobile, updateHeight ]);

    const slides = [
        { image: isMobile ? Step1Small: Step1, text: 'Создайте новый расчет доставки' },
        { image: isMobile ? Step2Small: Step2, text: 'Внесите данные по товарам и упаковке' },
        { image: isMobile ? Step3Small: Step3, text: 'Укажите данные по маршруту' },
        { image: isMobile ? Step4Small: Step4, text: 'Заполните данные по декларации' },
        { image: isMobile ? Step5Small: Step5, text: 'Выберите вариант сертификации' },
        { image: isMobile ? Step6Small: Step6, text: 'Укажите данные по счетам' },
        { image: isMobile ? Step7Small: Step7, text: 'Получите готовый расчет' },
    ];

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % slides.length);
    };

    const goToSlide = (index: number) => {
        setCurrentIndex(index);
    };

    const handlers = useSwipeable({
        onSwipedLeft: nextSlide,
        onSwipedRight: prevSlide,
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    const handleClickSlide = () => {
        if (!isMobile) return;
        setOpen(true);
    }

    return (
        <>
            <div className={styles.steps}>
                <Container className={styles.stepsContainer}>
                    <Row>
                        <Col xl={5} xxl={5} className={styles.titleContainer}>
                            <h2 className={styles.title}>Простота и&nbsp;ясность на&nbsp;каждом шаге</h2>
                            <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide className={styles.buttonTop}/>
                            <div className={styles.contentBig}>
                                <h3 className={styles.subtitle}>
                                    Шаг {currentIndex + 1} из 7
                                </h3>
                                <p className={styles.text}>
                                    {slides[currentIndex].text}
                                </p>
                                <div className={styles.navigation}>
                                    <div className={styles.navigationButtons}>
                                        {slides.map((_, index) => (
                                            <div className={styles.navigationButtonContainer} key={index}>
                                                <button
                                                    key={index}
                                                    onClick={() => goToSlide(index)}
                                                    className={cx(styles.navigationButton, {
                                                        [styles.navigationButtonActive]: currentIndex === index,
                                                    })}
                                                >
                                                    {currentIndex === index ? index + 1 : ''}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xl={7} xxl={7}>
                            <div className={styles.slider}>
                                <div className={styles.browser}>
                                    <ul className={styles.browserPanel}>
                                        <li className={cx(styles.browserButton, styles.browserCloseButton)}/>
                                        <li className={cx(styles.browserButton, styles.browserHideButton)}/>
                                        <li className={cx(styles.browserButton, styles.browserExpandButton)}/>
                                    </ul>
                                </div>
                                <div {...handlers} className={styles.sliderContainer}>
                                    {!isMobile && <>
                                        <div onClick={prevSlide} className={styles.sliderContainerButtonPrev}>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.82 31.4099L24 22.2499L33.18 31.4099L36 28.5899L24 16.5899L12 28.5899L14.82 31.4099Z" fill="currentColor"/>
                                            </svg>
                                        </div>
                                    </>}
                                    <Carousel
                                        controls={false}
                                        indicators={false}
                                        activeIndex={currentIndex}
                                        onSelect={(selectedIndex) => setCurrentIndex(selectedIndex)}
                                        interval={null}
                                    >
                                        {slides.map((slide, index) => (
                                            <Carousel.Item
                                                key={index}
                                            >
                                                <div
                                                     className={styles.scrollWrapper}
                                                     style={{
                                                         height: firstSlideHeight ? `${firstSlideHeight}px` : "auto",
                                                     }}
                                                     onClick={() => setOpen(true)}
                                                >
                                                    <Button variant="contained"
                                                            sx={{
                                                                letterSpacing: '0.46px',
                                                                padding: '7px 18px',
                                                                fontWeight: 600,
                                                                border: `1px solid ${COLORS.PRIMARY_LIGHT}`,
                                                                background: COLORS.WHITE,
                                                                fontSize: '15px',
                                                                fontStyle: 'normal',
                                                                lineHeight: 1.7,
                                                                textTransform: 'uppercase',
                                                                color: COLORS.PRIMARY,
                                                                position: 'absolute',
                                                                zIndex: 1,
                                                                top: '50%',
                                                                left: '50%',
                                                                marginTop: '-21px',
                                                                marginLeft: '-81px'
                                                            }}
                                                            className={styles.sliderButton}
                                                    >
                                                        <img src={PlusIcon} alt="Увеличить" className={styles.buttonZoomIcon} />
                                                        Увеличить
                                                    </Button>
                                                    <img
                                                        ref={index === 0 ? firstSlideRef : undefined}
                                                        src={slide.image}
                                                        alt={slide.text}
                                                        className={styles.slideImage}
                                                        draggable="false"
                                                        onClick={handleClickSlide}
                                                        onLoad={updateHeight}
                                                    />
                                                </div>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                    {!isMobile && (<div onClick={nextSlide} className={styles.sliderContainerButtonNext}>
                                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.82 31.4099L24 22.2499L33.18 31.4099L36 28.5899L24 16.5899L12 28.5899L14.82 31.4099Z" fill="currentColor"/>
                                        </svg>
                                    </div>)}
                                </div>
                                <div className={styles.browserNextWindow}/>
                                <div className={styles.browserLastWindow}/>
                            </div>
                            <div className={styles.contentSmall}>
                                <h3 className={styles.subtitle}>
                                    Шаг {currentIndex + 1} из 7
                                </h3>
                                <p className={styles.text}>
                                    {slides[currentIndex].text}
                                </p>
                                <div className={styles.navigation}>
                                    <div className={styles.navigationButtons}>
                                        {slides.map((_, index) => (
                                            <div className={styles.navigationButtonContainer} key={index}>
                                                <button
                                                    key={index}
                                                    onClick={() => goToSlide(index)}
                                                    className={cx(styles.navigationButton, {
                                                        [styles.navigationButtonActive]: currentIndex === index,
                                                    })}
                                                >
                                                    {currentIndex === index ? index + 1 : ''}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <ButtonPrimary href={VEDMARKET_LINKS.calculator} target="_blank" rel="noreferrer" label="Перейти к расчетам" isWide className={styles.buttonBottom}/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <StepsModal
                open={open}
                handleClose={() => setOpen(false)}
                currentIndex={currentIndex}
            />
        </>
    );
}

export default Steps;
